<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Profile</div>
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-title>
      <div class="body-2">{{labels.general}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.inter}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{intermediary.inter}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.intermediaryName}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div>{{intermediary.intermediaryName}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.interGroup}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div>{{intermediary.interGroupName}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.suspended}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div>{{formatBoolean(intermediary.suspended)}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.dateOpened}}</v-subheader>
            <div>{{formatDate(intermediary.dateOpened)}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.dateClosed}}</v-subheader>
            <div v-if="intermediary.dateClosed">{{formatDate(intermediary.dateClosed)}}</div>
            <div v-else>-</div>
          </v-flex>
          </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-title>
      <div class="body-2">{{labels.Contact}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.officeNo}}</v-subheader>
            <div v-if="intermediary.officeNo">{{intermediary.officeNo}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.faxNo}}</v-subheader>
            <div v-if="intermediary.faxNo">{{intermediary.faxNo}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.add3}}</v-subheader>
            <div v-if="intermediary.add3">{{intermediary.add3}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.postalCode}}</v-subheader>
            <div v-if="intermediary.postalCode">{{intermediary.postalCode}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.add1}}</v-subheader>
            <div v-if="intermediary.add1">{{intermediary.add1}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.add2}}</v-subheader>
            <div v-if="intermediary.add2">{{intermediary.add2}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.add4}}</v-subheader>
            <div v-if="intermediary.add4">{{intermediary.add4}}</div>
            <div v-else>-</div>
          </v-flex>
        </v-layout>
      </v-container>
        <v-flex lg6 md12 xs12>
          <v-btn color="primary" v-if="checkAccess(['intermediaryReview'])" @click="doReview">
            Edit Intermediary
            <v-icon right>mdi-pencil</v-icon>
          </v-btn>
        </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import toDate from 'date-fns/toDate'
import { formatDisplayDate } from '@/utils/date'
export default {
  data() {
    return {
      labels: {
        inter: 'Intermediary Code',
        intermediaryName: 'Intermediary Name',
        interGroup: 'Intermediary Group',
        dateOpened: 'Date Opended',
        dateClosed: 'Date Closed',
        officeNo: 'Office No.',
        faxNo: 'Fax No.',
        add1: 'Block/House No.',
        add2: 'Street Name',
        add3: 'Unit No.',
        add4: 'Building Name',
        postalCode: 'Postal Code',
        suspended: 'Is Suspended?',
        Contact: 'Contacts',
        general: 'General'
      },
      intermediary: {
        inter: undefined,
        intermediaryName: undefined,
        interGroupCode: undefined,
        interGroupName: undefined,
        dateOpened: undefined,
        dateClosed: undefined,
        officeNo: undefined,
        faxNo: undefined,
        add1: undefined,
        add2: undefined,
        add3: undefined,
        add4: undefined,
        postalCode: undefined,
        interProductId: []
      },
      menu: []
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  methods: {
    doReview() {
      this.$router.push({ name: 'reviewProfile', params: { inter: this.intermediary.inter } })
    },
    queryLimit() {
      this.$snotify.warning('Cannot do this in query mode')
    },
    doBack() {
      this.$router.push({ name: 'intermediaries' })
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(toDate(xDate))
      }
    },
    formatBoolean(val) {
      if (val === undefined) {
        return 'No'
      } else {
        if (val === true) {
          return 'Yes'
        } else {
          return 'No'
        }
      }
    }
  },
  created() {
    this.intermediary = this.$store.state.adminInter.intermediary
  },
  props: ['inter']
}
</script>

<style lang="scss">

</style>
